export enum FindTypes {
  COUNTRY = 'COUNTRY',
  CITY = 'CITY',
  AIRPORT = 'AIRPORT',
  BUS = 'BUS',
  ALLCITY = 'ALLCITY'
}
